// extracted by mini-css-extract-plugin
module.exports = {"links":"links_links__FkrKu","item":"links_item__vn0dD"};